import React from 'react';

interface TabIconProps {
  className?: string;
  width?: number;
  height?: number;
}

/** Bar chart icon for Performance tab (creators/advisors). */
export function TabIconPerformance({
  className = 'mobile-tab-bar-icon',
  width = 28,
  height = 28,
}: TabIconProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect x="4" y="14" width="4" height="10" rx="1" fill="currentColor" />
      <rect x="12" y="8" width="4" height="16" rx="1" fill="currentColor" />
      <rect x="20" y="4" width="4" height="20" rx="1" fill="currentColor" />
    </svg>
  );
}

/** Hamburger-style icon for traveler fourth tab → /my-travel (My Trips). */
export function TabIconContent({
  className = 'mobile-tab-bar-icon',
  width = 28,
  height = 28,
}: TabIconProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect x="5" y="6" width="18" height="3" rx="1.5" fill="currentColor" />
      <rect x="5" y="12.5" width="18" height="3" rx="1.5" fill="currentColor" />
      <rect x="5" y="19" width="18" height="3" rx="1.5" fill="currentColor" />
    </svg>
  );
}
